import styled, { css } from 'styled-components';

import { breakpoints, Heading } from '@notino/react-styleguide';

import { IProductsCount, IIsAsset } from '../model';

import { fifteenPx, colPct } from '.';

export const Header = styled.div<IProductsCount>`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.sm}) {
    flex-direction: row;
  }

  @media (min-width: ${breakpoints.md}) {
    ${(props) =>
      props.productsCount === 4
        ? ''
        : `
        flex-direction: column;
        flex: 1 1 ${props.productsCount === 3 ? colPct(4) : colPct(5)};
      `};
  }
`;

export const Asset = styled.div<IProductsCount>`
  flex-basis: ${colPct(12)};
  margin-right: 0;
  align-items: center;
  text-align: center;
  order: 5;
  display: none;

  @media (min-width: ${breakpoints.lg}) {
    display: block;
    order: 0;
    text-align: left;
    flex-basis: ${(props) => (props.productsCount === 4 ? colPct(4) : 'auto')};
    margin-right: ${(props) => (props.productsCount === 4 ? fifteenPx : 0)};

    img {
      max-width: 100%;
      height: auto;
      vertical-align: middle;
      border-style: none;
    }
  }

  ${({ productsCount }) =>
    css`
      @media (min-width: ${breakpoints.xl}) {
        flex-basis: ${productsCount === 4 ? colPct(3) : 'auto'};
      }
    `}
`;

export const Content = styled.div<IProductsCount & IIsAsset>`
  font-weight: 300;
  line-height: 1.4;
  flex-basis: ${colPct(12)};
  padding: 0 ${fifteenPx} ${fifteenPx};

  @media (min-width: ${breakpoints.md}) {
    flex-basis: ${(props) =>
      props.productsCount === 4 && props.isAsset ? colPct(8) : colPct(12)};
    ${(props) =>
      props.productsCount === 4 && props.isAsset
        ? 'margin-right: 5rem;'
        : `padding: ${fifteenPx};`};
  }
`;

export const Title = styled(Heading.H3)`
  font-size: 1.75rem !important;
  margin: 0.6rem 0 !important;
`;

export const Description = styled.div`
  font-size: 1rem;
`;
